<template>
  <div v-if="!isLoading" class="detail-info">
    <header class="detail-header">
      <div class="inner-wrapper">
        <h1>상세 정보</h1>
        <button type="button" class="btn-detail-back" @click="closePopup">뒤로 돌아가기</button>
      </div>
    </header>

    <div class="outer-wrapper">
      <div class="inner-wrapper">
        <section>
          <div class="season-area">
            <div>
              <div class="metadata">
                <h2 class="main-title">{{ title }}</h2>
                <p class="synopsis" v-html="synopsis" />
              </div>
              <div class="thumbnail">
                <img :src="getThumbnailImg(posterImage)" @load="onImageLoad" :alt="title">
                <span v-if="!isImageLoaded" class="skeleton" aria-hidden="true">썸네일 배경 영역</span>
              </div>
            </div>

            <table class="detail-info-table">
              <caption>영화 상세 정보 표</caption>
              <colgroup>
                <col :style="`width: ${ hasKmrbCode ? 68 : 42 }px`">
                <col>
              </colgroup>
              <tbody>
              <tr>
                <th scope="row">개요</th>
                <td>{{ summary }}</td>
              </tr>
              <tr v-if="hasTagList">
                <th scope="row">장르</th>
                <td>
                  <template v-for="(tag, index) in tagList">
                    <a :key="`${tag.value}_${index}`" href="javascript:void(0)" @click.prevent="clickTagFn(tag)">
                      #{{ textRender(tag.text, index, tagList) }}
                    </a>
                  </template>
                </td>
              </tr>
              <tr v-if="hasActorList">
                <th scope="row">출연</th>
                <td>
                  <template v-for="(actor, index) in actorList">
                    <a :key="`actors_${index}`" href="javascript:void(0)" @click.prevent="searchByKeywordFn(actor.value)">
                      {{ textRender(actor.text, index, actorList) }}
                    </a>
                  </template>
                </td>
              </tr>
              <tr v-if="hasDirectorList">
                <th scope="row">감독</th>
                <td>
                  <template v-for="(director, index) in directorList">
                    <a :key="`actors_${index}`" href="javascript:void(0)" @click.prevent="searchByKeywordFn(director.value)">
                      {{ textRender(director.text, index, directorList) }}
                    </a>
                  </template>
                </td>
              </tr>
              <tr>
                <th scope="row">등급</th>
                <td><AgeGrade :target-age="targetAge" :section="kmrbCode" /></td>
              </tr>
              <tr v-if="hasKmrbCode && hasGradeInfo">
                <th scope="row">내용정보</th>
                <td><GradeInfo :grade-info="gradeInfo" /></td>
              </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>

  </div>
</template>
<script>
import { get } from 'lodash'
import { MovieInfoService } from '@/common/api/api.service'
import { clickTag, searchByKeyword } from '@/common/util/player.util'
import { resizeThumbnail } from '@/common/image.filter'
import PlayerDetailInfoMixin from '@/components/play/mixins/player.detail.info.mixin'
import AgeGrade from '@/components/play/AgeGrade'
import GradeInfo from '@/components/play/GradeInfo'

export default {
  name: 'MovieDetailInfo',
  components: {
    AgeGrade,
    GradeInfo
  },
  mixins: [
    PlayerDetailInfoMixin
  ],
  data () {
    return {
      isOpenDetailPopup: false,
      contentInfo: {},
      tagList: [],
      isLoading: true,
      isImageLoaded: false
    }
  },
  computed: {
    summary () {
      const { cpname = '', country = '', releasedate = '' } = this.contentInfo
      const year = releasedate.substring(0, 4)
      const yearInfo = year.length > 0 ? `${year}년` : ''
      return [cpname, country, yearInfo].filter(infoText => infoText !== '').join(', ')
    },
    title () {
      return get(this.contentInfo, 'title', '')
    },
    synopsis () {
      return get(this.contentInfo, 'synopsis', '')
    },
    originTitle () {
      return get(this.contentInfo, 'origintitle', '')
    },
    deliverationInfo () {
      return get(this.contentInfo, 'deliverationinfo', '')
    },
    posterImage () {
      const { image = '', moviegroupimage = '', moviegrouptitlelogoimage = '' } = this.contentInfo
      return image || moviegroupimage || moviegrouptitlelogoimage
    },
    actorList () {
      return get(this.contentInfo, 'actors.list', [])
    },
    directorList () {
      return get(this.contentInfo, 'directors.list', [])
    },
    targetAge () {
      return get(this.contentInfo, 'targetage', '')
    },
    kmrbCode () {
      const kamrbcode = get(this.contentInfo, 'kmrbcode', '')
      return kamrbcode ? 'movie' : 'vod'
    },
    gradeInfo () {
      return get(this.contentInfo, 'gradeinfo', {})
    },
    hasTagList () {
      return this.tagList.length > 0
    },
    hasActorList () {
      return this.actorList.length > 0
    },
    hasDirectorList () {
      return this.directorList.length > 0
    },
    hasKmrbCode () {
      return get(this.contentInfo, 'kmrbcode', '').length > 0
    },
    hasGradeInfo () {
      return Object.values(this.gradeInfo).indexOf('') <= -1
    }
  },
  methods: {
    setData () {
      this.isLoading = true
      const movieID = get(this.$route, 'query.movieid', '')
      MovieInfoService.getMovieMetaInfo({ movieID }, (error) => {
        alert(error.response.data.resultmessage)
        this.routerBack()
      }).then(({ data }) => {
        this.contentInfo = data
        const tagCount = get(this.contentInfo, ['tags', 'count'], '')
        if (tagCount === '' || tagCount === '0') {
          this.isLoading = false
          return []
        }
        let tagList = get(this.contentInfo, ['tags', 'list'], []).map((tag) => {
          if (typeof tag === 'string') {
            return {
              text: tag,
              value: tag,
              taggroup: 'tag'
            }
          } else {
            if (tag.taggroup === undefined) {
              tag.taggroup = 'tag'
            }
            return tag
          }
        })
        this.tagList = tagList.filter((tag) => { return tag.text !== '' })
        this.isLoading = false
      })
    },
    closePopup () {
      this.$router.back()
    },
    searchByKeywordFn (keyword) {
      searchByKeyword({ keyword })
    },
    clickTagFn (tag) {
      clickTag({ currentSection: 'movie', tag, contentInfo: this.contentInfo })
    },
    textRender (text, index, totalList) {
      return `${text}${totalList.length - 1 > index ? ',' : ''} `
    },
    getThumbnailImg (posterImage) {
      const size = { width: 202, height: 302 }
      return resizeThumbnail(posterImage, { width: size.width, height: size.height, isSquare: false })
    },
    onImageLoad () {
      this.isImageLoaded = true
    }
  },
  created () {
    this.setData()
  }
}
</script>
